import Slider from "react-slick";
import Image from "next/image";

import { Box, SVGSprite } from "@/components/Atoms";

import styles from "./RegisterFormCarousel.module.scss";

const CarouselSlides = [
  {
    backgroundColor: "#FEC84B",
    color: "#7A2E0E",
    title: "Add variety to your  workouts! Try something new every week",
    thumbnail:
      "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-06/shyft-pass-carousel-1-68870f873e6640baab5e36353470d4c5.jpg",
  },
  {
    backgroundColor: "#B9E6FE",
    color: "#293056",
    title: "Meet like-minded folks",
    thumbnail:
      "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-06/shyft-pass-carousel-2-f91df3ddec3748419b6ac165241e862a.jpg",
  },
  {
    backgroundColor: "#FECDD6",
    color: "#89123E",
    title: "Best in class instructors for each workout",
    thumbnail:
      "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/shyft-pass-carousel-1.jpg",
  },
  {
    backgroundColor: "#A9E89F",
    color: "#054F31",
    title: "Convenient & interesting venues for workouts & mixers",
    thumbnail:
      "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/shyft-pass-carousel-2.jpg",
  },
];

const RegisterFormCarousel = () => {
  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <Box>
        <Box>
          <SVGSprite icon="icon-slider-arrow-left" height="24px" width="24px" />
        </Box>
      </Box>
    ),
    nextArrow: (
      <Box>
        <Box>
          <SVGSprite
            icon="icon-slider-arrow-right"
            height="24px"
            width="24px"
          />
        </Box>
      </Box>
    ),
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.25,
        },
      },
    ],
  };

  return (
    <div className={styles.registerCarousel}>
      <Slider {...settings}>
        {CarouselSlides.map(
          ({ backgroundColor, color, title, thumbnail }, index) => {
            return (
              <div key={index}>
                <div className={styles.card} style={{ backgroundColor }}>
                  <div className={styles.thumbnail}>
                    <Image
                      src={thumbnail}
                      alt={title || "workout-session"}
                      fill={true}
                    />
                  </div>
                  <div className={styles.content}>
                    <div className={styles.number}>
                      <span>0{index + 1}</span>
                    </div>
                    <div className={styles.title} style={{ color }}>
                      {title}
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        )}
      </Slider>
    </div>
  );
};

export default RegisterFormCarousel;
